import { render, staticRenderFns } from "./PortalDesignerReportVisualisations.vue?vue&type=template&id=2d9a987b&"
import script from "./PortalDesignerReportVisualisations.vue?vue&type=script&lang=js&"
export * from "./PortalDesignerReportVisualisations.vue?vue&type=script&lang=js&"
import style0 from "./PortalDesignerReportVisualisations.vue?vue&type=style&index=0&id=2d9a987b&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d9a987b')) {
      api.createRecord('2d9a987b', component.options)
    } else {
      api.reload('2d9a987b', component.options)
    }
    module.hot.accept("./PortalDesignerReportVisualisations.vue?vue&type=template&id=2d9a987b&", function () {
      api.rerender('2d9a987b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/pageDesigner/PortalDesignerReportVisualisations.vue"
export default component.exports